import React from 'react'

function Modal({ open, onClose, children }) {
  return (
    <div>
      {open && (
        <div
          onClick={onClose}
          className="tw-fixed tw-inset-0 tw-overflow-y-auto tw-overflow-x-hidden tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50"
        >
          <div onClick={(e) => e.stopPropagation()} className="tw-relative tw-p-4">
            <div className="tw-relative tw-bg-white tw-rounded-lg tw-shadow">
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Modal
